module.exports = __webpack_public_path__ + "static/media/s_array.2bf6e9fe.png";